import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataOrderComponent } from './data-order.component';
import { DetailDataOrderComponent } from './detail-data-order/detail-data-order.component';
import { PickupOrderComponent } from './pickup-order/pickup-order.component';

const routes: Routes = [
  { path: '', component: DataOrderComponent },
  { path: 'order-detail/:id', component: DetailDataOrderComponent },
  { path: 'pickup/:id', component: PickupOrderComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DataOrderRoutingModule { }
